export default "__VITE_ASSET__bCaKeOmU__"